export default __webpack_public_path__ + "static/flink-5139d61249738511f0fa013d7d48546a.png";